import { render } from "./AllNewReviews.vue?vue&type=template&id=38ccf941&scoped=true"
import script from "./AllNewReviews.vue?vue&type=script&lang=js"
export * from "./AllNewReviews.vue?vue&type=script&lang=js"

import "./AllNewReviews.vue?vue&type=style&index=0&id=38ccf941&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ccf941"]])

export default __exports__